<template>
  <div>
    <div class="current-position">
      <img class="common-banner2" src="../assets/img/banner.png" alt="">
      <div class="current-position-text">
        <div class="common-container">
          <div class="current-position-logotext">Academic Exchanqe</div>
        </div>
        <div class="common-container">
          当前位置: 首页  >  {{ menu.title }}
        </div>
      </div>
    </div>
    <div class="survey-module">
      <div class="common-container justify-between">
        <div class="survey-module-right" v-show="!detail_show">
          <div class="survey-module-right-title f-w">
            {{ menu.title }}
          </div>
          <div class="survey-module-right-action">
            <div class="new-list" v-if="menu_action.length>0">
              <div class="new-item" v-for="(item,index) in menu_action" :key="index" @click="openDetail(item)">
                <div class="new-item-action" v-if="!item.noShow">
                  <div class="new-item-action-img">
                    <img :src="$baseUrl+item.thumbnailUrl" alt="">
                  </div>
                  <div class="new-item-content flex-col justify-between">
                    <span>{{ item.title }}</span>
                    <!-- <span>{{ item.startTime}} ~ {{ item.endTime}}</span> -->
                    <span>地点：{{ item.address }}</span>
                  </div>
                  <div class="new-item-btn justify-center align-center">查看详情</div>
                </div>
              </div>
              <div class="pagination-content justify-end">
                <el-pagination
                  @size-change="handleSizeChange"
                  @current-change="handleCurrentChange"
                   :current-page="queryParams.pageNum"
                  :page-size="queryParams.pageSize"
                  background
                  layout="total,prev, pager, next, jumper"
                  prev-text="上一页"
                  next-text="下一页"
                  :total="total">
                </el-pagination>
              </div>
            </div>
            <el-empty class="survey-module-right-action-empty" v-else description="暂无内容"></el-empty>
          </div>
        </div>
        <div class="survey-module-right" v-show="detail_show">
          <span class="deatil-back" @click="offDetail()">返回</span>
          <div class="survey-module-right-title f-w justify-between">
            <span>{{ detail_obj.title }}</span>
            <span class="justify-end">{{ detail_obj.createTime }}</span>
          </div>
          <div class="survey-module-right-action">
            <div class="new-detail" v-html="detail_obj.content" v-if="detail_obj.content"></div>
            <el-empty class="survey-module-right-action-empty" v-else description="暂无内容"></el-empty>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
 
<script>
import {getList,getDeatil} from "@/api/wzgl";
export default {
  data(){
    return{
      menu:{
        title:'学术交流',
      },
      menu_id:this.$route.query.id,
      menu_action:[],
      queryParams:{
        pageNum: 1,
        pageSize: 9,
        type:'academic'
      },
      total:0,
      // 详情
      detail_show:false,
      detail_obj:{
        title:'',
        content:'',
        createTime:''
      }
    }
  },
  created(){
    this.getList()
    if('detail_id' in this.$route.query){
      getDeatil({id:this.$route.query.detail_id})
      .then((res)=>{
        if(res.code==200){
          this.detail_obj = res.data
          this.detail_show = true
        }
      })
    }
  },
  methods:{
    menuFun(id){
      this.menu_id = id
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.queryParams.pageNum = val
      this.getList()
    },
    getList(){
      getList(this.queryParams)
      .then(({ data }) => {
        this.menu_action = data.list
        let n = 3 - data.list.length%3
        if(n>0&&n<3){
          for(let i=0;i<n;i++){
            this.menu_action.push({ noShow:true})
          }
        }
        this.total = data.total;
      })
      .finally(() => {
      });
    },
    // openDetail(id){
    //  let name = this.menu.title
    //   let pathHerf = this.$router.resolve({
    //     path:'/detailPage',query:{detail_id:id,type:2,name}
    //   })
    //   window.open(pathHerf.href, '_blank');
    // }
    openDetail(row){
      this.detail_show = true
      this.detail_obj = row
      this.detail_obj.content = this.detail_obj.content.replace(/<img/g, "<img style='max-width:100%;height:auto;'")
      this.detail_obj.content = this.detail_obj.content.replace(/<video/g, "<video style='max-width:100%;height:auto;'")
      window.scrollTo(0,0);
    },
    offDetail(){
      if('detail_id' in this.$route.query){
        this.$router.go(-1)
      }else{
        this.detail_show = false
        this.detail_obj = {
          title:'',
          content:'',
          createTime:''
        }
      }
    }
  }
}
</script>
<style scoped lang="css" src="../assets/css/rem.css" />
<style scoped>

</style>
